export class MapRoutingConstants {
    static ESRI_MAP_ROUTE = "esri-map";
}
